import React, { type SyntheticEvent } from 'react';
import { useCommonClient } from '@/app/common/commonClientProvider.tsx';
import { useOverlayContext } from '@/app/common/context/OverlayContext.ts';
import BasicModalFooter from '../BasicModalFooter';
import BasicModalFooterV2, { type FooterLayout } from '../BasicModalFooterV2';

type ModalFooterProps = {
  applyText?: string;
  handleApply: (e: SyntheticEvent) => void;
  isApplyDisabled?: boolean;
  isApplyLoading?: boolean;
  clearText?: string;
  handleClear?: (e: SyntheticEvent) => void;
  isClearDisabled?: boolean;
  sticky?: boolean;
  layout?: FooterLayout;
  evo?: boolean;
} & React.HTMLAttributes<HTMLDivElement>;

const ModalFooter = ({ sticky, layout, isApplyLoading, evo, ...props }: ModalFooterProps) => {
  const { isEvoLayout } = useCommonClient();
  const { footerShadow } = useOverlayContext();
  return (evo ?? isEvoLayout) ? (
    <BasicModalFooterV2
      sticky={sticky}
      layout={layout}
      isApplyLoading={isApplyLoading}
      showShadow={footerShadow}
      data-swipe-dismiss-ignore={true}
      {...props}
    />
  ) : (
    <BasicModalFooter {...props} />
  );
};

export default ModalFooter;
